module.exports = __webpack_public_path__ + "static/media/8.dddd8420.jpg";